import React from 'react';
import { Card, CardContent } from '../ui/Card';
import { cn } from '../../lib/utils';

export function JourneyKpiCard({ label, value, detail, className }) {
  return (
    <Card className={cn('min-w-0', className)}>
      <CardContent className="flex min-h-[6.5rem] flex-col justify-center px-4 py-4">
        <p className="font-display text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500">
          {label}
        </p>
        <p className="mt-2 text-xl font-bold tabular-nums tracking-tight text-[#201C35] sm:text-[1.35rem]">
          {value}
        </p>
        {detail ? <p className="mt-1 text-[11px] leading-snug text-slate-500">{detail}</p> : null}
      </CardContent>
    </Card>
  );
}

export function JourneyKpiRow({ items = [], className }) {
  return (
    <div className={cn('grid min-w-0 gap-2.5 sm:grid-cols-2 xl:grid-cols-4', className)}>
      {items.map((item) => (
        <JourneyKpiCard
          key={item.id || item.label}
          label={item.label}
          value={item.value}
          detail={item.detail}
        />
      ))}
    </div>
  );
}
